(function () {
  var root = document.querySelector('[data-scw-first-order]');
  if (!root) return;

  var storageKey = 'scwFirstOrderOfferMinimized';
  var openButton = root.querySelector('[data-scw-first-order-open]');
  var dismissButton = root.querySelector('[data-scw-first-order-dismiss]');
  var reopenButton = root.querySelector('[data-scw-first-order-reopen]');
  var closeButtons = root.querySelectorAll('[data-scw-first-order-close]');
  var overlay = root.querySelector('[data-scw-first-order-overlay]');
  var modal = root.querySelector('[data-scw-first-order-modal]');
  var copyButton = root.querySelector('[data-scw-first-order-copy]');
  var success = root.querySelector('[data-scw-first-order-success]');
  var lastFocused = null;

  function visibleBottomOverlayHeight(id) {
    var element = document.getElementById(id);
    if (!element || !element.getBoundingClientRect) return 0;

    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle ? window.getComputedStyle(element) : null;
    var visible = rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
    var hidden = styles && (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0');
    var nearBottom = Math.abs(window.innerHeight - rect.bottom) < 120 || rect.bottom >= window.innerHeight - 4;

    return visible && !hidden && nearBottom ? rect.height : 0;
  }

  function updateBottomOffset() {
    var baseOffset = window.matchMedia('(max-width: 749px)').matches ? 10 : 16;
    var offset = baseOffset;
    var cookieHeight = visibleBottomOverlayHeight('shopify-pc__banner');
    var previewHeight = visibleBottomOverlayHeight('PBarNextFrameWrapper');
    var modalBottom = baseOffset;

    if (cookieHeight) offset += cookieHeight + 10;
    if (previewHeight) {
      offset += previewHeight + 10;
      modalBottom = previewHeight + 10;
    }

    root.style.setProperty('--scw-first-order-bottom', Math.round(offset) + 'px');
    root.style.setProperty('--scw-first-order-modal-bottom', Math.round(modalBottom) + 'px');
  }

  function setMinimizedState(minimized) {
    root.classList.toggle('is-minimized', minimized);
    try {
      if (minimized) {
        window.sessionStorage.setItem(storageKey, 'true');
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {
      return;
    }
  }

  function restoreMinimizedState() {
    try {
      if (window.sessionStorage.getItem(storageKey) === 'true' && !success) {
        root.classList.add('is-minimized');
      }
    } catch (error) {
      return;
    }
  }

  function focusFirstField() {
    var target = modal.querySelector('input, button, a[href], [tabindex]:not([tabindex="-1"])');
    if (target) target.focus();
  }

  function openModal() {
    if (!modal || !overlay) return;
    setMinimizedState(false);
    lastFocused = document.activeElement;
    overlay.hidden = false;
    modal.hidden = false;
    document.documentElement.classList.add('scw-first-order-lock');
    window.setTimeout(focusFirstField, 30);
  }

  function closeModal() {
    if (!modal || !overlay) return;
    overlay.hidden = true;
    modal.hidden = true;
    document.documentElement.classList.remove('scw-first-order-lock');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  restoreMinimizedState();
  updateBottomOffset();
  if (window.MutationObserver) {
    new MutationObserver(updateBottomOffset).observe(document.documentElement, { childList: true, subtree: true, attributes: true });
  }
  window.addEventListener('resize', updateBottomOffset);

  if (openButton) {
    openButton.addEventListener('click', openModal);
  }

  if (dismissButton) {
    dismissButton.addEventListener('click', function () {
      setMinimizedState(true);
      closeModal();
    });
  }

  if (reopenButton) {
    reopenButton.addEventListener('click', openModal);
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) {
      closeModal();
    }
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var codeNode = root.querySelector('[data-scw-first-order-code]');
      var code = codeNode ? codeNode.textContent.trim() : '';
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyButton.textContent = 'Copied';
        }).catch(function () {
          copyButton.textContent = code;
        });
      } else {
        copyButton.textContent = code;
      }
    });
  }

  if (success) {
    setMinimizedState(false);
    openModal();
  }
})();
